import React from 'react';
import { styled } from '@abyss/web/tools/styled';
import { Heading } from '@abyss/web/ui/Heading';
import { Text } from '@abyss/web/ui/Text';
import { SearchForm } from './SearchForm';

const PaceAdminHeading = styled(Heading, {
  '&.abyss-heading-root': {
    fontWeight: 'bold',
    fontSize: '28px',
    marginTop: '20px',
  },
});

const PaceAdminTextContent = styled(Text, {
  '&.abyss-text-root': {
    marginBottom: '20px',
    color: '#333333',
    fontSize: '16px',
    fontWeight: '500',
  },
});

export const PaceAdmin = () => {
  return (
    <React.Fragment>
      <PaceAdminHeading display="h3">PACE Administrator</PaceAdminHeading>
      <PaceAdminTextContent>
        The ID you signed in with has PACE Admin access.
      </PaceAdminTextContent>
      <SearchForm />
    </React.Fragment>
  );
};
